import React from "react"

import { Card, Col } from "react-bootstrap"

function ReviewCard(props) {
    return (
        <Col as={Card} xs={12} lg={6} className="p-0 mt-5">
            <Card.Body>
                <Card.Title>
                    <h2>What do our clients think?</h2>
                </Card.Title>

                <p className="d-inline">
                    <i>&ldquo;{props.review}&rdquo;</i>
                </p>

                <p className="h5 mt-3 text-end">{props.reviewer}</p>
            </Card.Body>
        </Col>
    )
}

export default ReviewCard
